import Spinner from "./spinner";

const ButtonDanger = (props: any) => {

  let textButton = props.textButton ?? '';
  let spinner = props.spinner ?? false;
  let disabled = props.disabled ?? false;
  return (
    <>
      <button disabled={disabled} onClick={props.handleChange} className="btn btnDanger  m - 1">
        {textButton}
        {spinner &&
          <Spinner />
        }
      </button >
    </>
  )
}

export default ButtonDanger;
